<div class="rose-portal-card-title-component">
    <h2>{{ title() }}</h2>
    <p>{{ subtitle() }}</p>
</div>